import React, {useEffect} from "react"
import { isAndroid, isIOS } from 'react-device-detect'

export default () => {
    useEffect(() => {
        if (isAndroid) window.location.href = 'https://play.google.com/store/apps/details?id=eu.getthebox.gettheboxapp';
        else if (isIOS) window.location.href = 'https://apps.apple.com/app/id1439490396';
        else window.location.href = 'https://getthebox.eu';
    }, []);

    return (
        <div>
            Trwa przekierowanie dla właściwej platformy...
        </div>
    )
}
